import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactImageLightbox from 'react-image-lightbox';
import PhotoCreditLink from '../PhotoCreditLink';
import { lockScrollForLightbox, unlockScrollForLightbox } from '../../../utils/lightbox_helpers';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import 'react-image-lightbox/style.css'; // this is an import for the plugin
import './styles/overrides.scss';

class Lightbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: props.startingIndex,
      photoCreditProps: {},
      showPhotoCredit: false,
      loading: false
    };
  }

  componentDidMount() {
    lockScrollForLightbox();
    this.fetchCreditLink();
  }

  componentWillUnmount() {
    unlockScrollForLightbox();
  }

  clearPhotoCredit() {
    this.setState({ showPhotoCredit: false, photoCreditProps: {} });
  }

  handleComplete = e => {
    this.setState({ loading: false });
  };

  handleSuccess = photoCreditProps => {
    this.setState({ photoCreditProps, showPhotoCredit: true });
  };

  handleError = e => {
    this.clearPhotoCredit();
  };

  generateUrl() {
    let url = `/photos/${this.props.images[this.state.photoIndex].id}/credit-link`;
    const { showCreditActions, trailId, mapId } = this.props;
    const query = showCreditActions ? '&' : '?';
    if (showCreditActions) {
      url = `${url}?showActions=${showCreditActions}`;
    }

    if (trailId) {
      url = `${url}${query}provide_set_as_default=true`;
    } else if (mapId) {
      url = `${url}${query}provide_map_id=${this.props.mapId}`;
    } else {
      url = `${url}${query}provide_trail_links=true`;
    }

    return url;
  }

  fetchCreditLink() {
    if (!this.props.images[this.state.photoIndex].id) {
      this.clearPhotoCredit();
      return;
    }

    if (this.state.loading) {
      return;
    }

    this.setState({ loading: true });
    const url = this.generateUrl();
    ServerCommunicationUtil.getApiEndpoint(url, {}, this.handleSuccess, this.handleError, this.handleComplete, {}, 'json');
  }

  handleOnCloseRequest = () => {
    this.props.handleCloseRequest();
  };

  handleOnMovePrevRequest = () => {
    const { photoIndex } = this.state;
    const imagesLength = this.props.images.length;

    this.setState(
      {
        photoIndex: (photoIndex + imagesLength - 1) % imagesLength,
        photoCreditProps: {},
        showPhotoCredit: false
      },
      this.fetchCreditLink
    );
  };

  handleOnMoveNextRequest = () => {
    const { photoIndex } = this.state;
    const imageLength = this.props.images.length;

    this.setState(
      {
        photoIndex: (photoIndex + 1) % imageLength,
        photoCreditProps: {},
        showPhotoCredit: false
      },
      this.fetchCreditLink
    );
  };

  renderPhotoCredit() {
    return <div className="credit-link-container">{this.state.showPhotoCredit && <PhotoCreditLink {...this.state.photoCreditProps} />}</div>;
  }

  render() {
    const { images } = this.props;
    const { photoIndex } = this.state;
    const customStyles = {
      overlay: {
        zIndex: 1005
      },
      captionContent: {
        width: '100%'
      }
    };
    return (
      <ReactImageLightbox
        reactModalStyle={customStyles}
        wrapperClassName="react-image-lightbox"
        mainSrc={images[photoIndex].url}
        nextSrc={images[(photoIndex + 1) % images.length].url}
        prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
        onCloseRequest={this.handleOnCloseRequest}
        onMovePrevRequest={this.handleOnMovePrevRequest}
        onMoveNextRequest={this.handleOnMoveNextRequest}
        imageCaption={this.renderPhotoCredit()}
      />
    );
  }
}

Lightbox.propTypes = {
  isOpen: PropTypes.bool,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      id: PropTypes.number
    })
  ),
  handleCloseRequest: PropTypes.func,
  startingIndex: PropTypes.number,
  trailId: PropTypes.number,
  mapId: PropTypes.number
};

export default Lightbox;
